var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo/invite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "72.8286301%",
    x2: "79.3721548%",
    y2: "26.3696411%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo/invite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125,18 C30.80625,18 33,20.26875 33,23.0625 L33,24.1875 C33,26.98125 30.825,29.25 28.125,29.25 L19.3125,29.25 C16.63125,29.25 14.25,26.98125 14.25,24.1875 L14.25,23.625 C14.25,23.00625 14.75625,22.5 15.375,22.5 C15.99375,22.5 16.5,23.00625 16.5,23.625 L16.5,24.1875 C16.5,25.74375 17.86875,27 19.3125,27 L28.125,27 C29.56875,27 30.75,25.74375 30.75,24.1875 L30.75,23.0625 C30.75,21.50625 29.56875,20.25 28.125,20.25 L22.89375,20.25 C22.275,20.25 21.76875,19.74375 21.76875,19.125 C21.76875,18.50625 22.275,18 22.89375,18 L28.125,18 Z M12.35625,27 C12.975,27 13.48125,27.50625 13.48125,28.125 C13.48125,28.74375 12.975,29.25 12.35625,29.25 L7.875,29.25 C5.19375,29.25 3,26.98125 3,24.1875 L3,23.0625 C3,20.26875 5.175,18 7.875,18 L16.6875,18 C19.36875,18 21.75,20.26875 21.75,23.0625 L21.75,23.625 C21.75,24.24375 21.24375,24.75 20.625,24.75 C20.00625,24.75 19.5,24.24375 19.5,23.625 L19.5,23.0625 C19.5,21.50625 18.13125,20.25 16.6875,20.25 L7.875,20.25 C6.43125,20.25 5.25,21.50625 5.25,23.0625 L5.25,24.1875 C5.25,25.74375 6.43125,27 7.875,27 L12.35625,27 Z M24.375,8.25 C22.93125,8.25 21.75,9.43125 21.75,10.875 C21.75,12.31875 22.93125,13.5 24.375,13.5 C25.81875,13.5 27,12.31875 27,10.875 C27,9.43125 25.81875,8.25 24.375,8.25 L24.375,8.25 Z M24.375,15.75 C21.69375,15.75 19.5,13.55625 19.5,10.875 C19.5,8.19375 21.69375,6 24.375,6 C27.05625,6 29.25,8.19375 29.25,10.875 C29.25,13.55625 27.05625,15.75 24.375,15.75 L24.375,15.75 Z M11.625,8.25 C10.18125,8.25 9,9.43125 9,10.875 C9,12.31875 10.18125,13.5 11.625,13.5 C13.06875,13.5 14.25,12.31875 14.25,10.875 C14.25,9.43125 13.06875,8.25 11.625,8.25 L11.625,8.25 Z M11.625,15.75 C8.94375,15.75 6.75,13.55625 6.75,10.875 C6.75,8.19375 8.94375,6 11.625,6 C14.30625,6 16.5,8.19375 16.5,10.875 C16.5,13.55625 14.30625,15.75 11.625,15.75 L11.625,15.75 Z",
    id: "invite",
    fill: "url(#linearGradient-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteLogo);
export default __webpack_public_path__ + "d5e694cea8e52a1cb93ed7b6b1f81d14.svg";
export { ForwardRef as ReactComponent };